import {
  AbsoluteFill,
  interpolate,
  Sequence,
  useCurrentFrame,
  useVideoConfig,
  Video
} from 'remotion';

import { DEFAULT_TRANSITION_DURATION } from '@/constants';
import { VideoType } from '@/enums/RemotionEnums';

export type VideoSequenceProps = {
  from: number;
  durationInFrames: number;
  videoSrc: string;
  videoType?: VideoType;
  firstBackgroundVideo?: boolean;
  lastBackgroundVideo?: boolean;
};

export const VideoSequence: React.FC<VideoSequenceProps> = ({
  from,
  durationInFrames,
  videoSrc,
  videoType,
  firstBackgroundVideo,
  lastBackgroundVideo
}) => {
  const currentFrame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const opacity =
    currentFrame >= from &&
    currentFrame <= from + DEFAULT_TRANSITION_DURATION * fps &&
    (videoType !== VideoType.BACKGROUND || !!firstBackgroundVideo)
      ? interpolate(currentFrame, [from, from + DEFAULT_TRANSITION_DURATION * fps], [0, 1])
      : currentFrame >= durationInFrames - DEFAULT_TRANSITION_DURATION * fps &&
          currentFrame <= durationInFrames &&
          (videoType !== VideoType.BACKGROUND || !!lastBackgroundVideo)
        ? interpolate(
            currentFrame,
            [durationInFrames - DEFAULT_TRANSITION_DURATION * fps, durationInFrames],
            [1, 0.1]
          )
        : 1;

  return (
    <Sequence from={from} durationInFrames={durationInFrames}>
      <AbsoluteFill style={{ opacity: opacity }}>
        <Video src={videoSrc} />
      </AbsoluteFill>
    </Sequence>
  );
};
